<template>
  <div class="max-w-[80rem] p-8 mx-auto w-full h-full relative">
    <div class="bg-[#FBFBFC] h-full py-6 rounded-3xl shadow-b-xl">
      <div class="h-full px-6 overflow-auto">
        <div class="py-4"></div>

        <div class="px-6 flex flex-col md:flex-row justify-between md:items-center gap-6">
          <div class="flex items-center gap-6">

            <div class="w-6 h-6" @click="$router.back()">
              <img
                src="@/assets/images/all/arrow-up-black.svg"
                class="object-contain w-full h-full -rotate-90"
                alt=""
              />
            </div>
            <div class="text-2xl font-bold title-color">
              Détail de la commande
            </div>
          </div>
          <div class="">
            <button
              class="py-1 px-3 rounded-lg flex items-center gap-2  text-xl relative"
              :style="{
                backgroundColor: statuses[orderData.status]?.background,
                color: statuses[orderData.status]?.color,
              }"
            >
              <div>
                {{ statuses[orderData.status]?.name || orderData.status }}
              </div>
              <!-- <div class="w-6 h-6">
                <img
                  class="w-full h-full"
                  src="@/assets/images/all/pen.svg"
                  alt=""
                />
              </div> -->
            </button>
          </div>
        </div>
        <div class="py-3 border-b"></div>
        <div class="py-3"></div>
        <div class="flex gap-6 flex-col py-2 px-6">
          <div
            class="flex justify-between items-start gap-4"
            v-for="(product, i) in orderData.products"
            :key="i"
          >
            <div class="flex items-start gap-3 w-4/5">
              <div class="h-14 w-14 min-w-14 rounded-xl overflow-hidden">
                <img :src="product.image" class="w-full h-full object-cover" />
              </div>
              <div class="">
                <p class="title-color">
                  {{ product.name }}
                </p>
                <!-- <div class="pt-1"></div> -->
                <p class="text-sm">
                  {{ product.quantity }} x {{ product.price }} FCFA
                </p>
                <div class="pt-1"></div>
              </div>
            </div>
            <span class=" md:text-xl title-color text-right"> {{ product.price }}&nbsp;FCFA </span>
          </div>
        </div>
        <div class="py-4"></div>
        <div class="grid col-span-1 md:grid-cols-3 gap-4">
          <div class="md:col-span-2 rounded-xl p-4 border">
            <div class="font-bold text-2xl">Détails de Livraison</div>
            <div class="py-2"></div>
            <div class="flex flex-col gap-4">
              <div class="flex">
                <div
                  class="font-bold w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
                >
                  Pays
                </div>
                <div class="title-color">
                  {{
                    $Countries.find(orderData.shippingAddress.countryCode)
                      .countryName
                  }}
                </div>
              </div>
              <div class="flex">
                <div
                  class="font-bold w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
                >
                  Vile
                </div>
                <div class="title-color">
                  {{ orderData.shippingAddress.city }}
                </div>
              </div>
              <div class="flex">
                <div
                  class="font-bold w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
                >
                  Prénom
                </div>
                <div class="title-color">
                  {{ orderData.shippingAddress.firstName }}
                </div>
              </div>
              <div class="flex">
                <div
                  class="font-bold w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
                >
                  Nom
                </div>
                <div class="title-color">
                  {{ orderData.shippingAddress.lastName }}
                </div>
              </div>
              <div class="flex">
                <div
                  class="font-bold w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
                >
                  Téléhpone à contacter
                </div>
                <div class="title-color">
                  {{ orderData.shippingAddress.phoneToCall }}
                </div>
              </div>
              <div class="flex">
                <div
                  class="font-bold w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
                >
                  District/Quartier
                </div>
                <div class="title-color">
                  {{ orderData.shippingAddress.district }}
                </div>
              </div>
              <div class="flex">
                <div
                  class="font-bold w-[10rem] min-w-[10rem] md:w-[18rem] md:min-w-[18rem]"
                >
                  Plus de détails de localisation
                </div>
                <div class="title-color">
                  {{ orderData.shippingAddress.locationDetails }}
                </div>
              </div>
            </div>
          </div>
          <div class="rounded-xl p-3 border">
            <div class="font-bold text-2xl">Détails de paiement</div>
            <div class="py-3"></div>
            <div class="flex flex-col gap-4">
              <div class="">
                <div class="title-color">
                  <div class="w-24 h-24">
                    <img
                      class="w-full h-full"
                      :src="orderData.customerImageUrl"
                      alt=""
                    />
                  </div>
                  <div>
                    {{ orderData.customerName }}
                  </div>
                  <div>
                    {{ orderData.customerEmail }}
                  </div>
                </div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">Date</div>
                <div class="title-color">
                  {{
                    $Commons.timestampToDate(
                      orderData.orderDate,
                      'DD MMM YYYY, hh:mm',
                    )
                  }}
                </div>
              </div>
              <div class="flex justify-between">
                <div class="font-bold">Methode de paiement</div>
                <div class="title-color">
                  {{ paymentMethods[orderData.paymentMethod] }}
                </div>
              </div>
              <div class="flex justify-between text-xl">
                <div class="font-bold">Montant total</div>
                <div class="title-color">{{ orderData.totalPrice }} FCFA</div>
              </div>
            </div>
          </div>
        </div>
        <!-- {{ orderData }} -->
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'OrderDetails',
  components: {},
  props: {
    orderData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      statuses: {
        all: { id: 'all', name: 'Tout' },
        initial: {
          id: 'initial',
          name: 'Paiement en cours',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        paid: {
          id: 'paid',
          name: 'Payé',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        paymentFailed: {
          id: 'failed',
          name: 'Paiement échoué',
          background: '#EEF2F3',
          color: '#696969',
        },
        processing: {
          id: 'processing',
          name: 'Livraison en cours',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        delivered: {
          id: 'delivered',
          name: 'Délivré',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        refunded: { id: 'refunded', name: 'Rémboursé' },
        // failed: {
        //   id: 'failed',
        //   name: 'Echoué',
        //   background: '#EEF2F3',
        //   color: '#696969',
        // },
      },
      paymentMethods: {
        card: 'Carte bancaire',
        mobileMoney: 'Mobile Money',
      },
    }
  },
  mounted() {},
  unmounted() {},
  methods: {
    
    async startStatusUpdate(order) {
      const options = [
        {
          id: 'processing',
          name: 'Livraison en cours',
        },
        {
          id: 'delivered',
          name: 'Délivré',
        },
        { id: 'refunded', name: 'Rémboursé' },
      ]
      const prompt = await window.choicePrompt({
        title: "Modifier l'état de la commande",
        subtitle:
          'Cette modification permettra au client de savoir où en est sa commande',
        options,
        formatDisplay: data => data?.name || '',
        successText: 'Enrégistrer',
      })
      if (!prompt.accepted || !prompt.data) return null
      console.log(prompt.data)
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent('order_status_update_available', {
        id: order.id,
        status: prompt.data.id,
      })
    },
  },
  computed: {},
  watch: {},
})
</script>
